<template>
  <div style="padding-top: 50px">
    <div
      class="base-header"
      style="
        text-align: center;
        line-height: 50px;
        background-color: #fff;
        z-index: 999;
      "
    >
      {{ $t("match.title") }}
    </div>
    <div class="view-page" style="padding-top: 0; padding-bottom: 50px">
      <div class="main-banner">
        <img src="../../assets/img/home/815d0e61346bceb133080059c5aa947c.gif" />
      </div>
      <van-tabs v-model="active" swipeable @change="tabChange">
        <van-tab :title="$t('common.all')" />
        <van-tab
          v-for="(item, index) in addlist"
          :key="index"
          :title="item.yn_yu"
        />
      </van-tabs>
      <van-pull-refresh
        :pulling-text="$t('common.repulling')"
        :loosing-text="$t('common.reloosing')"
        :loading-text="$t('common.reloading')"
        :success-text="$t('common.resuccess')"
        class="list-wrapper"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <van-grid :column-num="2" :gutter="10" :border="false">
          <van-grid-item
            @click="profile(v.id)"
            v-for="(v, k) in datalist"
            :key="k"
          >
            <div style="position: relative">
              <van-image class="game_item_img" :src="v.img_url">
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <div class="img-tip">
                <div style="float: left; width: 50%" class="van-ellipsis">
                  <van-icon
                    name="location-o"
                    color="#fff"
                    size="14"
                    style="margin-left: 4px"
                  />&nbsp;<span style="font-size: 14px">{{
                    toClass(v.class_id)
                  }}</span>
                </div>
                <div style="float: left; width: 50%">
                  <div
                    style="
                      border: 1px solid #fff;
                      border-radius: 6px;
                      font-size: 10px;
                      margin: 4px;
                      height: 20px;
                      line-height: 20px;
                      text-align: center;
                    "
                  >
                    {{ $t("index.apply") }}
                  </div>
                </div>
                <div style="clear: both" />
              </div>
            </div>
            <div class="tips" v-if="v.tag" style="font-size: 12px">
              <span
                v-for="(t, ti) in v.tag.split('#')"
                :key="ti"
                :style="!(t && t.length > 0) ? 'display:none' : ''"
                >{{ t }}</span
              >
            </div>
            <div style="width: 100%;margin: 8px 0px;">
                <van-row>
                    <van-col span="12" style="font-size: 14px;overflow: hidden;height: 18px;" >
                        <i v-if="v.yn_yu"
                  style="
                    display: inline-block;
                    margin-right: 0.2rem;
                    width: 0.8rem;
                    height: 0.8rem;
                    border-radius: 50%;
                    background: #efba8f;
                  "
                ></i
                >{{ v.yn_yu }}
                    </van-col>
                    <van-col span="12" style="text-align: right;">
                        <van-icon name="like" size="14px" color="rgb(220, 99, 161)" /> {{ v.hot }}
                    </van-col>
                </van-row>
              
            </div>
          </van-grid-item>
        </van-grid>
      </van-pull-refresh>
    </div>
    <FooterView />
  </div>
</template>

<script>
import FooterView from "@/components/Footer/index.vue";
export default {
  name: "MatchView",
  components: { FooterView },
  data() {
    return {
      addlist: [],
      active: 0,
      vod_name: null,
      isLoading: false,
      datalist: [],
      id: null,
    };
  },
  methods: {
    getAddress() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        this.addlist = res.data;
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.datalist = [];
        this.getxuanfeilist();
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    profile(id) {
      this.$router.push({
        path:
          "/profile?id=" +
          id +
          "&name=" +
          this.vod_name +
          "&adsid=" +
          this.$route.query.id,
      });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: this.id },
      }).then((res) => {
        this.datalist = res.data;
        console.log(this.datalist);
      });
    },
    toClass(id) {
      try {
        return this.addlist.filter((x) => x.id == id)[0].yn_yu;
      } catch {
        return "";
      }
    },
    tabChange(val) {
      if (val != 0) this.id = this.addlist[val].id;
      else this.id = null;
      this.onRefresh();
    },
  },
  mounted() {
    this.getAddress();
    this.getxuanfeilist();
  },
};
</script>
<style lang="scss" scoped>
.main-banner {
  width: 96%;
  margin: 10px auto;
  img {
    width: 100%;
    border-radius: 10px;
  }
}
</style>
<style lang="scss">
.game_item_img {
  border-radius: 10px !important;
  img {
    border-radius: 10px !important;
  }
}
.img-tip {
  position: absolute;
  background: rgb(0, 0, 0, 0.65);
  width: 100%;
  color: #fff;
  left: 0px;
  bottom: 0px;
  height: 28px;
  line-height: 28px;
}
</style>
